import { render, staticRenderFns } from "./OrderReports.vue?vue&type=template&id=6cc79b1e&scoped=true&"
import script from "./OrderReports.vue?vue&type=script&lang=js&"
export * from "./OrderReports.vue?vue&type=script&lang=js&"
import style0 from "./OrderReports.vue?vue&type=style&index=0&id=6cc79b1e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc79b1e",
  null
  
)

export default component.exports